<template>
  <jet-authentication-card>
    <AppHead title="Forgot Password" />
    <template #logo>
      <jet-authentication-card-logo />
    </template>

    <div class="card-body">
      <div class="mb-2 text-secondary">
        Forgot your password? No problem. Just let us know your email address and we will email you a password reset link that will allow you to choose a new one.
      </div>

      <div v-if="status" class="alert alert-success" role="alert">
        {{ status }}
      </div>

      <jet-validation-errors class="mb-2" />

      <form @submit.prevent="submit">
        <div class="row">
          <div class="col-12 col-lg-7">
            <InteractiveInput 
            icon="fas fa-envelope" 
            formLabel="Email"
            v-model="form.email"
            :error="Object.keys($page.props.errors).length"
            :formAttr="{
              id: 'email',
              type: 'email',
              classes: 'form-control',
              required: true,
              autofocus: true,
              modelValue:form.email
            }"/>
          </div>
          <div class="col-12 col-lg-5 d-flex align-items-end">
            <jet-button :class="{ 'text-white-50': form.processing }" type="submit" class="w-100 text-nowrap mt-3 mt-lg-0" :disabled="form.processing">
              Email Password Reset Link
            </jet-button>
          </div>
        </div>
      </form>
    </div>
  </jet-authentication-card>
</template>

<script>
  import JetAuthenticationCard from '@/Jetstream/AuthenticationCard'
  import JetAuthenticationCardLogo from '@/Jetstream/AuthenticationCardLogo'
  import JetButton from '@/Jetstream/Button'
  import JetInput from '@/Jetstream/Input'
  import JetLabel from '@/Jetstream/Label'
  import JetValidationErrors from '@/Jetstream/ValidationErrors'
  import InteractiveInput from '@/Shared/InteractiveInput'

  export default {
    components: {
      JetAuthenticationCard,
      JetAuthenticationCardLogo,
      JetButton,
      JetInput,
      JetLabel,
      JetValidationErrors,
      InteractiveInput
    },
    props: {
      status: String
    },
    data() {
      return {
        form: this.$inertia.form({
          email: ''
        })
      }
    },
    methods: {
      submit() {
        this.form.post(this.route('password.email'))
      }
    }
  }
</script>
